import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaWhatsapp } from "react-icons/fa";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import facebook from "../assets/images/facebook-f.png";
import telegram from "../assets/images/telegram-f.png";
import support from "../assets/images/support-f.png";
import whatsapp from "../assets/images/whatsapp.svg";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { isMobile } from "react-device-detect";
const Footer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const [icon, setIcon] = useState({});
  const sidebarModalAccount = useContextSelector(AuthContext, (ctx) => {
    return ctx.sidebarModalAccount;
  });
  const sidebarModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.sidebarModal;
  });
  const getData = async () => {
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    const { data } = await apiGet(apiPath?.getSetting, {
      website: hostname,
    });
    if (data?.success) {
      setIcon(data?.results);
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <div
      style={{ marginBottom: "50px" }}
      className="footer-wrap ng-star-inserted"
    >
      <footer className="footer">
        {location?.pathname == "/" && !sidebarModalAccount && !sidebarModal && (
          <>
           <div class="float-service">
        <div class="service-list">
          <div class="service-item" onClick={() => {
            window.open(icon?.whatsappContent ? "https://wa.me/" + icon?.whatsappContent : "https://wa.me/+", "_self");
          }}>
            <img class="service-icon" src={whatsapp} />
          </div>
          <div class="service-item" onClick={() => {
            window.open("https://www.facebook.com/", "_self");
          }}>
            <img class="service-icon" src={facebook} />
          </div>
          <div class="service-item" onClick={() => {
            window.open(icon?.telegramContent ? icon?.telegramContent : "https://t.me/", "_self");
          }}>
            <img class="service-icon" src={telegram} />
          </div>
          <div class="service-item" onClick={() => {
            window.open("https://tawk.to/chat/");
          }}>
            <img class="service-icon" src={support} />
          </div>
        </div>
      </div>
          </>
        )}
        <div className="footer-collapse">
          {/**/}
          {/**/}
          <mcd-footer-description-inr-en
            className="ng-star-inserted"
            style={{}}
          >
            <div className="footer-collapse__title ng-star-inserted">
              Conquer the Action and the Casino World with skybaji!
            </div>
            <div className="footer-collapse__content ng-star-inserted">
              <p>
                Welcome to skybaji, a place where sports passion and casino
                excitement meet on one easy-to-use platform. From heart-racing
                sports moments to chilled casino play, skybaji is made for
                players who enjoy both action and variety without needing to
                switch platforms all the time.
              </p>
              <br />
              <p>
                We at skybaji believe that gaming should always be fun and
                exciting for players. Whether you love betting, just spinning
                reels or something fast, we always want our players to have fun
                while being responsible.
              </p>
              <br />
              <p>
                <strong className="footer-collapse__strong">Our Origins</strong>
              </p>
              <br />
              <p>
                skybaji was founded in 2017, built by a team that understands
                online betting and gaming from real experience. What started as
                a small project slowly turned into one of Asia's more trusted
                online casino and sports betting platforms. Today, skybaji
                serves over 2 million players across India, Bangladesh, Vietnam,
                and the Philippines.
              </p>
              <br />
              <p>
                Operating under a Curaçao gaming license, our team includes
                gaming specialists, sports followers, and casino professionals
                who know what players actually want. We're not here to be just
                another website, to be honest. Our goal has always been to
                create a platform people can come back to again and again.
              </p>
              <br />
              <p>
                <strong className="footer-collapse__strong">Our Mission</strong>
              </p>
              <br />
              <p>
                At skybaji, our mission is clear, even if simple – to offer a
                smooth, enjoyable, and rewarding gaming experience for players
                across Asia. Whether you're placing thoughtful sports bets or
                playing casino games after a long day, we want your time here to
                feel well spent.
              </p>
              <br />
              <p>
                We focus on platform stability, fast loading games, and features
                that actually make sense. Everything we add or improve is based
                on player feedback, so you spend more time playing and less time
                dealing with problems.
              </p>
              <br />
              <p>
                <strong className="footer-collapse__strong">
                  Sportsbook Experience
                </strong>
              </p>
              <br />
              <p>
                Here in skybaji, we provide players with a large variety of
                sportsbook options covering all the major sports out there and
                the lesser-known ones as well. From cricket, tennis, basketball,
                kabaddi, horse-racing, e-sports and more. Players can explore
                many different markets with competitive odds here.
              </p>
              <br />
              <p>
                Other than that, skybaji also offers live betting features that
                allows for players to place bets while the matches are still
                ongoing. With real-time updates and clear options, players will
                be able to respond accordingly with confidence.
              </p>
              <br />
              <p>
                <strong className="footer-collapse__strong">
                  Casino Entertainment
                </strong>
              </p>
              <br />
              <p>
                skybaji offers a large variety of online casino games and sports
                betting options for those who love variety when it comes to
                games. Here, you will be able to find online slots, live dealer,
                table games, arcade, card game, fishing, crash games and lottery
                all at the same place. To ensure fairness, seamless gaming
                experience, a variety of visuals and safety, we only work with
                trustworthy game providers.
              </p>
              <br />
              <p>
                Whether you love spinning slot reels, playing with cards,
                betting smartly or fast-paced games like crash games, we have
                all that and more here. You can choose to play any of the games
                according to your mood.
              </p>
              <br />
              <p>
                <strong className="footer-collapse__strong">
                  Payments and Support
                </strong>
              </p>
              <br />
              <p>
                skybaji supports many different currencies such as INR, BDT,
                VND, and PHP. Therefore, making deposits and withdrawals will
                not be a difficult feat as there are many payment options
                offered according to the countries you are playing from as well.
                All our payment options are safe, secure and trustworthy.
              </p>
              <br />
              <p>
                Our 24/7 customer support team also works around the clock to
                provide players with prompt solutions and answers. Players can
                reach us by either email, live chat feature and social media
                messaging.
              </p>
              <br />
              <p>
                <strong className="footer-collapse__strong">
                  Trust and Security
                </strong>
              </p>
              <br />
              <p>
                To us, our player's safety and security matter a lot. skybaji
                utilises state of art SSL encryption, modern firewalls and
                passwords to ensure that all personal as well as financial
                details provided by players are protected. Our system goes
                through regular monitoring to ensure transparency and fairness.
              </p>
              <br />
              <p>
                Responsible gaming is also highly encouraged here. We encourage
                all our players to smartly utilise all the gaming tools
                available to practice this.
              </p>
              <br />
              <p>
                <strong className="footer-collapse__strong">
                  Join the skybaji Community
                </strong>
              </p>
              <br />
              <p>
                No matter if you're here mainly for sports betting, casino
                games, or a mix of both, skybaji is happy to have you. With
                regular bonuses, a large game selection, and reliable support,
                we continue to grow together with our players.
              </p>
              <br />
              <p>
                Here's to exciting matches, lucky spins, and endless
                entertainment at skybaji.
              </p>
            </div>
            {/**/}
            {/**/}
          </mcd-footer-description-inr-en>
          {/**/}
          {/**/}
          <div className="footer-collapse__btn">
            {" "}
            Read More{" "}
            <div
              className="footer-collapse__btn-arrow"
              style={{
                "mask-image":
                  'url("https://img.b5611vs.com/bvs/h5/assets/images/icon-set/player/kyc/accordion-arrow.svg?v=1780386009683")',
              }}
            />
          </div>
        </div>
        <div className="row">
          <mcd-icon-list _nghost-serverapp-c1907600589 className="pay">
            <div
              _ngcontent-serverapp-c1907600589
              className="pay ng-star-inserted"
            >
              <h2 _ngcontent-serverapp-c1907600589>{t("PaymentMethods")}</h2>
              <ul _ngcontent-serverapp-c1907600589>
                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay16"
                    src="/assets/Footer/pay16.webp?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={122}
                    height={45}
                    style={{ "aspect-ratio": "122 / 45" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay22"
                    src="/assets/Footer/pay22.webp?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={68}
                    height={30}
                    style={{ "aspect-ratio": "68 / 30" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay33"
                    src="/assets/Footer/pay33.webp?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={46}
                    height={30}
                    style={{ "aspect-ratio": "46 / 30" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay34"
                    src="/assets/Footer/pay34.webp?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={68}
                    height={30}
                    style={{ "aspect-ratio": "68 / 30" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay45"
                    src="/assets/Footer/pay45.webp?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={87}
                    height={30}
                    style={{ "aspect-ratio": "87 / 30" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay48"
                    src="/assets/Footer/pay48.webp?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={165}
                    height={30}
                    style={{ "aspect-ratio": "165 / 30" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay59"
                    src="/assets/Footer/pay59.webp?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={122}
                    height={45}
                    style={{ "aspect-ratio": "122 / 45" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay60"
                    src="/assets/Footer/pay60.webp?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={153}
                    height={45}
                    style={{ "aspect-ratio": "153 / 45" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="pay61"
                    src="/assets/Footer/pay61.webp?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={39}
                    height={39}
                    style={{ "aspect-ratio": "39 / 39" }}
                  />
                </li>
              </ul>
            </div>
          </mcd-icon-list>
        </div>
        <div style={{ display: "flex", width: "100%" }}>
          <div
            _ngcontent-serverapp-c1751455638
            className="footer-social ng-star-inserted"
          >
            <h2 _ngcontent-serverapp-c1751455638 className="footer__title">
              {t("ResponsibleGaming")}
            </h2>
            <ul _ngcontent-serverapp-c1751455638 className="icon-list__items">
              <li
                _ngcontent-serverapp-c1751455638
                className="icon-list__item ng-star-inserted"
              >
                <img
                  _ngcontent-serverapp-c1751455638
                  className="icon-list__image ng-star-inserted"
                  fetchpriority="low"
                  alt="gamcare"
                  src="/assets/NewIcon/gamcare.png?v=1776751585885&source=mcdsrc"
                  loading="lazy"
                  width={28}
                  height={30}
                  style={{ "aspect-ratio": "28 / 30" }}
                />
                {/**/}
                {/**/}
                {/**/}
                {/**/}
              </li>
              {/**/}
              <li
                _ngcontent-serverapp-c1751455638
                className="icon-list__item ng-star-inserted"
              >
                <img
                  _ngcontent-serverapp-c1751455638
                  className="icon-list__image ng-star-inserted"
                  fetchpriority="low"
                  alt="age-limit"
                  src="/assets/NewIcon/age-limit.png?v=1776751585885&source=mcdsrc"
                  loading="lazy"
                  width={30}
                  height={30}
                  style={{ "aspect-ratio": "30 / 30" }}
                />
                {/**/}
                {/**/}
                {/**/}
                {/**/}
              </li>
              {/**/}
              <li
                _ngcontent-serverapp-c1751455638
                className="icon-list__item ng-star-inserted"
              >
                <img
                  _ngcontent-serverapp-c1751455638
                  className="icon-list__image ng-star-inserted"
                  fetchpriority="low"
                  alt="regulations"
                  src="/assets/NewIcon/regulations.png?v=1776751585885&source=mcdsrc"
                  loading="lazy"
                  width={29}
                  height={30}
                  style={{ "aspect-ratio": "29 / 30" }}
                />
                {/**/}
                {/**/}
                {/**/}
                {/**/}
              </li>
              {/**/}
              {/**/}
            </ul>
          </div>
          <div
            _ngcontent-serverapp-c3151814184
            className="footer-social ng-star-inserted"
            style={{}}
          >
            <h2 _ngcontent-serverapp-c3151814184>{t("CommunityWebsites")}</h2>
            <ul _ngcontent-serverapp-c3151814184>
              <li _ngcontent-serverapp-c3151814184 className="ng-star-inserted">
                <a
                  _ngcontent-serverapp-c3151814184
                  href="#"
                  className="ng-star-inserted"
                >
                  <img
                    _ngcontent-serverapp-c3151814184
                    alt="facebook"
                    fetchpriority="low"
                    src="/assets/Footer/facebook.webp?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    width={22}
                    height={22}
                    style={{ "aspect-ratio": "30 / 30" }}
                  />
                </a>
              </li>

              <li _ngcontent-serverapp-c3151814184 className="ng-star-inserted">
                <a
                  _ngcontent-serverapp-c3151814184
                  href="#"
                  className="ng-star-inserted"
                >
                  <img
                    _ngcontent-serverapp-c3151814184
                    alt="instagram"
                    fetchpriority="low"
                    src="/assets/Footer/instagram.webp?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    width={22}
                    height={22}
                    style={{ "aspect-ratio": "30 / 30" }}
                  />
                </a>
              </li>

              <li _ngcontent-serverapp-c3151814184 className="ng-star-inserted">
                <a
                  _ngcontent-serverapp-c3151814184
                  href="#"
                  className="ng-star-inserted"
                >
                  <img
                    _ngcontent-serverapp-c3151814184
                    alt="telegram-channel"
                    fetchpriority="low"
                    src="/assets/Footer/telegram-channel.webp?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    width={150}
                    height={150}
                    style={{ "aspect-ratio": "30 / 30" }}
                  />
                </a>
              </li>

              <li _ngcontent-serverapp-c3151814184 className="ng-star-inserted">
                <a
                  _ngcontent-serverapp-c3151814184
                  href="#"
                  className="ng-star-inserted"
                >
                  <img
                    _ngcontent-serverapp-c3151814184
                    alt="twitter"
                    fetchpriority="low"
                    src="/assets/Footer/twitter.webp?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    width={150}
                    height={150}
                    style={{ "aspect-ratio": "30 / 30" }}
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="row" style={{ borderTop: ".32vw solid #444444" }}>
          <mcd-about-us _nghost-serverapp-c3419815403 className="about-us">
            <div
              _ngcontent-serverapp-c3419815403
              className="about-us ng-star-inserted"
            >
              <h2 _ngcontent-serverapp-c3419815403>{t("ABOUTUS")}</h2>
              <ul _ngcontent-serverapp-c3419815403>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/responsiblegambling"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    {" "}
                    {t("ResponsibleGaming")}{" "}
                  </Link>
                </li>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/privacypolicy"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    {" "}
                    {t("PrivacyPolicy")}{" "}
                  </Link>
                </li>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/rulesandregulations"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    Ruels & Regulations
                  </Link>
                </li>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/18"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    18+
                  </Link>
                </li>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/aboutus"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    {" "}
                    {t("ABOUTUS")}{" "}
                  </Link>
                </li>
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/kyc"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    KYC
                  </Link>
                </li>
                {/* <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <a
                    _ngcontent-serverapp-c3419815403
                    href="/bd/en/vip-detail"
                    className="ng-star-inserted"
                  >
                    {" "}
                    {t("VIP")}{" "}
                  </a>
                </li> */}
                <li
                  _ngcontent-serverapp-c3419815403
                  className="ng-star-inserted"
                >
                  <Link
                    _ngcontent-serverapp-c3419815403
                    to="/terms/termsandconditions"
                    className="ng-star-inserted"
                    state={{ background: location }}
                  >
                    {" "}
                    {t("TermsConditions")}{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </mcd-about-us>
        </div>
        <div style={{ width: "100%" }} className="row">
          <mcd-icon-list _nghost-serverapp-c1907600589 className="license">
            <div
              _ngcontent-serverapp-c1907600589
              className="license ng-star-inserted"
            >
              <h2 _ngcontent-serverapp-c1907600589>{t("GamingLicense")}</h2>
              <ul _ngcontent-serverapp-c1907600589>
                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    width={172}
                    height={56}
                    alt="license1"
                    src="/assets/Footer/license1.webp?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    style={{ "aspect-ratio": "172 / 56" }}
                  />
                </li>

                <li
                  _ngcontent-serverapp-c1907600589
                  className="ng-star-inserted"
                  style={{}}
                >
                  <img
                    _ngcontent-serverapp-c1907600589
                    fetchpriority="low"
                    alt="anjouan-egaming"
                    src="/assets/Footer/anjouan-egaming.webp?v=1772072361392&source=mcdsrc"
                    loading="lazy"
                    className="ng-star-inserted"
                    width={142}
                    height={60}
                    style={{ "aspect-ratio": "142 / 60" }}
                  />
                </li>
              </ul>
            </div>
          </mcd-icon-list>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
